import { Body, Button, FlexBox, FormControl, Input } from '@Backlot-Cars/archie';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'next-i18next';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import SignUpHeader from 'partials/sign_up/header';

const getLookupValidationSchema = (t) =>
	Yup.object({
		auctionAccessId: Yup.string()
			.trim()
			.required(t('signup:auctionAccessLookup.formErrors.auctionAccessId'))
			.matches(/^\d+$/, t('signup:auctionAccessLookup.formErrors.auctionAccessId')),
		photoIdLastFour: Yup.string()
			.required(t('signup:auctionAccessLookup.formErrors.photoIdLastFour'))
			.matches(/^[a-zA-Z0-9]{4}$/, t('signup:auctionAccessLookup.formErrors.photoIdLastFour')),
	});

const AuctionAccessLookupForm = ({ onBack, onSubmit }) => {
	const { t } = useTranslation(['signup']);
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		defaultValues: {
			auctionAccessId: '',
			photoIdLastFour: '',
		},
		resolver: yupResolver(getLookupValidationSchema(t)),
	});

	const handleFormSubmit = ({ auctionAccessId, ...values }) =>
		onSubmit({ auctionAccessId: auctionAccessId.trim(), ...values });

	return (
		<FlexBox flexDirection="column" gap="lg">
			<SignUpHeader
				title={t('signup:auctionAccessLookup.entry.title')}
				subTitle={t('signup:auctionAccessLookup.entry.subTitle')}
			/>
			<FlexBox flexDirection="column" gap="md">
				<FormControl label={t('signup:auctionAccessLookup.entry.auctionAccessId')} required formErrors={errors}>
					<Input id="auctionAccessId" maxLength="9" inputMode="numeric" {...register('auctionAccessId')} />
				</FormControl>
				<FlexBox flexDirection="column" gap="xs">
					<FormControl
						label={t('signup:auctionAccessLookup.entry.photoIdLastFour')}
						required
						formErrors={errors}
					>
						<Input
							id="photoIdLastFour"
							maxLength="4"
							type="password"
							placeholder={t('signup:auctionAccessLookup.entry.photoIdLastFourPlaceholder')}
							{...register('photoIdLastFour')}
						/>
					</FormControl>
					<Body color="secondary" size="larger">
						{t('signup:auctionAccessLookup.entry.photoIdLastFourExample')}
					</Body>
				</FlexBox>
			</FlexBox>
			<FlexBox
				alignItems="center"
				flexDirection="row-reverse"
				gap="sm"
				justifyContent="space-between"
				width="100%"
			>
				<Button type="submit" onClick={handleSubmit(handleFormSubmit)}>
					{t('signup:auctionAccessLookup.entry.continue')}
				</Button>
				<Button variant="tertiary" onClick={onBack}>
					{t('signup:actions.back')}
				</Button>
			</FlexBox>
		</FlexBox>
	);
};

export default AuctionAccessLookupForm;
